export const PIDData = [
  {
    id: "img1",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Rotary Pump     /     Fan - General",
    src: "./pid-symbols/RotaryPumpFan-General.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img2",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Rotary Pump - Centrifugal",
    src: "./pid-symbols/RotaryPump-Centrifugal.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img3",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Rotary Pump - Grinder",
    src: "./pid-symbols/RotaryPump-Grinder.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img4",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Rotary Pump - Submersible",
    src: "./pid-symbols/RotaryPump-Submersible.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img5",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Rotary Pump - Submersible Grinder",
    src: "./pid-symbols/RotaryPump-SubmersibleGrinder.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img6",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Axial Fan Blower",
    src: "./pid-symbols/AxialFanBlower.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img7",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Positive Displacement - Progressive Cavity",
    src: "./pid-symbols/PositiveDisplacement-ProgressiveCavity.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img8",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Positive Displacement - Screw Pump",
    src: "./pid-symbols/PositiveDisplacement-ScrewPump.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img9",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Rotary Pump - Positive Displacement",
    src: "./pid-symbols/RotaryPump-PositiveDisplacement.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img10",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Rotary Pump - Lobe",
    src: "./pid-symbols/RotaryPump-Lobe.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img11",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Metering Pump",
    src: "./pid-symbols/MeteringPump.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img12",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Carboy Pump",
    src: "./pid-symbols/CarboyPump.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img13",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Archimedean Screw Tank Circulation Pump",
    src: "./pid-symbols/ArchimedeanScrewTankCirculationPump.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img14",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Reciprocating Pump Compressor",
    src: "./pid-symbols/ReciprocatingPumpCompressor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img15",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Two Stage Reciprocating Compressor",
    src: "./pid-symbols/TwoStageReciprocatingCompressor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img16",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Archimedean Screw Pump",
    src: "./pid-symbols/ArchimedeanScrewPump.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img17",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Centrifugal Axial Flow Compressor",
    src: "./pid-symbols/CentrifugalAxialFlowCompressor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img18",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Axial Flow Fan",
    src: "./pid-symbols/AxialFlowFan.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img19",
    group: "Pumps/Fans/Blower/Compressors",
    category: "Progressive Cavity Macerator Pump",
    src: "./pid-symbols/ProgressiveCavityMaceratorPump.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img20",
    group: "Motors/Drives",
    category: "Electric Motor - Fixed Speed",
    src: "./pid-symbols/ElectricMotor-FixedSpeed.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img21",
    group: "Motors/Drives",
    category: "Electric Motor - Variable Speed",
    src: "./pid-symbols/ElectricMotor-VariableSpeed.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img22",
    group: "Motors/Drives",
    category: "Air Motor",
    src: "./pid-symbols/AirMotor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img23",
    group: "Motors/Drives",
    category: "Reciprocating Engine",
    src: "./pid-symbols/ReciprocatingEngine.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img24",
    group: "Motors/Drives",
    category: "Gear Box",
    src: "./pid-symbols/GearBox.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img25",
    group: "Motors/Drives",
    category: "Fan",
    src: "./pid-symbols/Fan.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img26",
    group: "Heat Exchangers",
    category: "Basic Heat Exchanger",
    src: "./pid-symbols/BasicHeatExchanger.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img27",
    group: "Heat Exchangers",
    category: "Air Blown Cooler",
    src: "./pid-symbols/AirBlownCooler.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img28",
    group: "Heat Exchangers",
    category: "Forced Draft Cooling Tower",
    src: "./pid-symbols/ForcedDraftCoolingTower.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img29",
    group: "Heat Exchangers",
    category: "Refrigerator Drier",
    src: "./pid-symbols/RefrigeratorDrier.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img30",
    group: "Heat Exchangers",
    category: "After Cooler",
    src: "./pid-symbols/AfterCooler.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img31",
    group: "Heat Exchangers",
    category: "Basic Element Heater",
    src: "./pid-symbols/BasicElementHeater.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img32",
    group: "Heat Exchangers",
    category: "Concentric Tube Exchanger",
    src: "./pid-symbols/ConcentricTubeExchanger.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img33",
    group: "Heat Exchangers",
    category: "Plate Type Exchanger",
    src: "./pid-symbols/PlateTypeExchanger.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img34",
    group: "Heat Exchangers",
    category: "Shell and Tube Heat Exchanger",
    src: "./pid-symbols/ShellAndTubeExchanger.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img35",
    group: "Heat Exchangers",
    category: "Shell and Tube Heat Exchanger (Removable Tubes)",
    src: "./pid-symbols/ShellAndTubeExchanger(RemovableTubes).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img36",
    group: "Conveyors",
    category: "Basic Belt Conveyor",
    src: "./pid-symbols/BasicBeltConveyor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img37",
    group: "Conveyors",
    category: "Basic Belt Conveyor with Chevrons",
    src: "./pid-symbols/BasicBeltConveyorWithChevrons.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img38",
    group: "Conveyors",
    category: "Scraper Conveyor",
    src: "./pid-symbols/ScraperConveyor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img39",
    group: "Conveyors",
    category: "Scraper Conveyor with Incline",
    src: "./pid-symbols/ScraperConveyorWithIncline.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img40",
    group: "Conveyors",
    category: "Screw Conveyor",
    src: "./pid-symbols/ScrewConveyor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img41",
    group: "Conveyors",
    category: "Screw Conveyor with Incline",
    src: "./pid-symbols/ScrewConveyorWithIncline.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img42",
    group: "Conveyors",
    category: "Screw Conveyor - Reversing",
    src: "./pid-symbols/ScrewConveyor-Reversing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img43",
    group: "Conveyors",
    category: "Bucket Elevator",
    src: "./pid-symbols/BucketElevator.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img44",
    group: "Conveyors",
    category: "Weigh Feeder",
    src: "./pid-symbols/WeighFeeder.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img45",
    group: "Conveyors",
    category: "Vibrator Feeder",
    src: "./pid-symbols/VibratorFeeder.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img46",
    group: "Conveyors",
    category: "Screw Feeder",
    src: "./pid-symbols/ScrewFeeder.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img47",
    group: "Mixers",
    category: "Inline Static Mixer",
    src: "./pid-symbols/InlineStaticMixer.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img48",
    group: "Mixers",
    category: "Static Tube Aerator Mixer",
    src: "./pid-symbols/StaticTubeAeratorMixer.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img49",
    group: "Mixers",
    category: "Impeller Mixer",
    src: "./pid-symbols/ImpellerMixer.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img50",
    group: "Mixers",
    category: "Paddle Type Floculator",
    src: "./pid-symbols/PaddleTypeFloculator.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img51",
    group: "Mixers",
    category: "Paddle Mixer",
    src: "./pid-symbols/PaddleMixer.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img52",
    group: "Mixers",
    category: "High Speed Stirring Device",
    src: "./pid-symbols/HighSpeedStirringDevice.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img53",
    group: "Mixers",
    category: "Low Speed Stirring Device",
    src: "./pid-symbols/LowSpeedStirringDevice.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img54",
    group: "Mixers",
    category: "Dechlorination Tablet Feeder",
    src: "./pid-symbols/DechlorinationTabletFeeder.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img55",
    group: "Screens",
    category: "Hand Raked Screen",
    src: "./pid-symbols/HandRakedScreen.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img56",
    group: "Screens",
    category: "Curved Bar Screen",
    src: "./pid-symbols/CurvedBarScreen.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img57",
    group: "Screens",
    category: "Curved Bar Screen with Rotating Arm",
    src: "./pid-symbols/CurvedBarScreenWithRotatingArm.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img58",
    group: "Screens",
    category: "Vertical Bar Screen",
    src: "./pid-symbols/VerticalBarScreen.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img59",
    group: "Screens",
    category: "Rotary Brushed Screen",
    src: "./pid-symbols/RotaryBrushedScreen.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img60",
    group: "Screens",
    category: "Drum Screen",
    src: "./pid-symbols/DrumScreen.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img61",
    group: "Screens",
    category: "Cup Screen",
    src: "./pid-symbols/CupScreen.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img62",
    group: "Screens",
    category: "Vertical Step",
    src: "./pid-symbols/VerticalStepScreen.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img63",
    group: "Screens",
    category: "Vertical Band",
    src: "./pid-symbols/VerticalBandScreen.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img64",
    group: "Aerators",
    category: "Aerator",
    src: "./pid-symbols/Aerators.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img65",
    group: "Aerators",
    category: "Surface Aerator Type SA",
    src: "./pid-symbols/SurfaceAeratorTypeSA.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img66",
    group: "Aerators",
    category: "Surface Aerator Type SA (Floating)",
    src: "./pid-symbols/SurfaceAeratorTypeSA(Floating).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img67",
    group: "Aerators",
    category: "Surface Aerator Type TMA",
    src: "./pid-symbols/SurfaceAeratorTypeTMA.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img68",
    group: "Aerators",
    category: "High Speed Aerator",
    src: "./pid-symbols/HighSpeedAerator.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img69",
    group: "Aerators",
    category: "Horizontal Rotor",
    src: "./pid-symbols/HorizontalRotor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img70",
    group: "Burners",
    category: "Oil Burner",
    src: "./pid-symbols/OilBurner.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img71",
    group: "Burners",
    category: "Gas Burner",
    src: "./pid-symbols/GasBurner.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img72",
    group: "Pipelines",
    category: "Major Pipeline",
    src: "./pid-symbols/MajorPipeLine.png",
    StaticProps1: "Above Ground / Below Ground",
    StaticProps2: "Fluid Code",
    StaticProps3: "Maximum Fluid Operating Pressure (barg)",
    StaticProps4: "Size (NB or OD) (mm or inches)",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img73",
    group: "Pipelines",
    category: "Minor Pipeline",
    src: "./pid-symbols/MinorPipeLine.png",
    StaticProps1: "Above Ground / Below Ground",
    StaticProps2: "Fluid Code",
    StaticProps3: "Maximum Fluid Operating Pressure (barg)",
    StaticProps4: "Size (NB or OD) (mm or inches)",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img74",
    group: "Pipelines",
    category: "Dual Contained Pipeline",
    src: "./pid-symbols/DualContainedPipeLine.png",
    StaticProps1: "Above Ground / Below Ground",
    StaticProps2: "Fluid Code",
    StaticProps3: "Maximum Fluid Operating Pressure (barg)",
    StaticProps4: "Size (NB or OD) (mm or inches)",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img75",
    group: "Pipelines",
    category: "Major Pipeline - Existing",
    src: "./pid-symbols/MajorPipeLine-Existing.png",
    StaticProps1: "Above Ground / Below Ground",
    StaticProps2: "Fluid Code",
    StaticProps3: "",
    StaticProps4: "Maximum Fluid Operating Pressure (barg)",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img76",
    group: "Pipelines",
    category: "Minor Pipeline - Existing",
    src: "./pid-symbols/MinorPipeLine-Existing.png",
    StaticProps1: "Above Ground / Below Ground",
    StaticProps2: "Fluid Code",
    StaticProps3: "",
    StaticProps4: "Maximum Fluid Operating Pressure (barg)",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img77",
    group: "Pipelines",
    category: "Future Pipeline",
    src: "./pid-symbols/FuturePipeLine.png",
    StaticProps1: "Above Ground / Below Ground",
    StaticProps2: "Fluid Code",
    StaticProps3: "",
    StaticProps4: "Maximum Fluid Operating Pressure (barg)",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img78",
    group: "Signal Lines",
    category: "General Signal",
    src: "./pid-symbols/GeneralSignal.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img79",
    group: "Signal Lines",
    category: "Electric Signal",
    src: "./pid-symbols/ElectricSignal.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img80",
    group: "Signal Lines",
    category: "Pneumatic Signal",
    src: "./pid-symbols/PneumaticSignal.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img81",
    group: "Signal Lines",
    category: "Hydraulic Signal",
    src: "./pid-symbols/HydraulicSignal.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img82",
    group: "Signal Lines",
    category: "Capillary Signal",
    src: "./pid-symbols/CapillarySignal.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img83",
    group: "Signal Lines",
    category: "General Signal - Existing",
    src: "./pid-symbols/GeneralSignal-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img84",
    group: "Signal Lines",
    category: "Electric Signal - Exisiting",
    src: "./pid-symbols/ElectricSignal-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img85",
    group: "Signal Lines",
    category: "Pneumatic Signal - Existing",
    src: "./pid-symbols/PneumaticSignal-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img86",
    group: "Signal Lines",
    category: "Hydraulic Signal - Existing",
    src: "./pid-symbols/HydraulicSignal-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img87",
    group: "Signal Lines",
    category: "Capillary Signal - Existing",
    src: "./pid-symbols/CapillarySignal-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img88",
    group: "Valves",
    category: "General Valve (Open)",
    src: "./pid-symbols/GeneralValve(Open).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img89",
    group: "Valves",
    category: "General Valve (Closed)",
    src: "./pid-symbols/GeneralValve(Closed).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img90",
    group: "Valves",
    category: "Butterfly Valve (Open)",
    src: "./pid-symbols/ButterflyValve(Open).png",
    StaticProps1: "Drilling Specification",
    StaticProps2: "Head Works Specification",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img91",
    group: "Valves",
    category: "Butterfly Valve (Closed)",
    src: "./pid-symbols/ButterflyValve(Closed).png",
    StaticProps1: "Drilling Specification",
    StaticProps2: "Head Works Specification",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img92",
    group: "Valves",
    category: "Diaphragm Valve (Open)",
    src: "./pid-symbols/DiaphragmValve(Open).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img93",
    group: "Valves",
    category: "Diaphragm Valve (Closed)",
    src: "./pid-symbols/DiaphragmValve(Closed).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img94",
    group: "Valves",
    category: "Ball Valve (Open)",
    src: "./pid-symbols/BallValve(Open).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img95",
    group: "Valves",
    category: "Ball Valve (Closed)",
    src: "./pid-symbols/BallValve(Closed).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img96",
    group: "Valves",
    category: "Globe Valve (Open)",
    src: "./pid-symbols/GlobeValve(Open).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img97",
    group: "Valves",
    category: "Globe Valve (Closed)",
    src: "./pid-symbols/GlobeValve(Closed).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img98",
    group: "Valves",
    category: "Plug Valve (Open)",
    src: "./pid-symbols/PlugValve(Open).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img99",
    group: "Valves",
    category: "Plug Valve (Closed)",
    src: "./pid-symbols/PlugValve(Closed).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img100",
    group: "Valves",
    category: "Gate Valve (Open)",
    src: "./pid-symbols/GateValve(Open).png",
    StaticProps1: "Drilling Specification",
    StaticProps2: "Gear Box Required",
    StaticProps3: "Head Works Specification",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "Valve Orientation",
    StaticProps7: "Valve Type",
  },
  {
    id: "img101",
    group: "Valves",
    category: "Gate Valve (Closed)",
    src: "./pid-symbols/GateValve(Closed).png",
    StaticProps1: "Drilling Specification",
    StaticProps2: "Gear Box Required",
    StaticProps3: "Head Works Specification",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "Valve Orientation",
    StaticProps7: "Valve Type",
  },
  {
    id: "img102",
    group: "Valves",
    category: "Pinch Valve (Open)",
    src: "./pid-symbols/PinchValve(Open).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img103",
    group: "Valves",
    category: "Pinch Valve (Closed)",
    src: "./pid-symbols/PinchValve(Closed).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img104",
    group: "Valves",
    category: "Parallel Slide Valve (Open)",
    src: "./pid-symbols/ParallelSlideValve(Open).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img105",
    group: "Valves",
    category: "Parallel Slide Valve (Closed)",
    src: "./pid-symbols/ParallelSlideValve(Closed).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img106",
    group: "Valves",
    category: "Needle Valve (Open)",
    src: "./pid-symbols/NeedleValve(Open).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img107",
    group: "Valves",
    category: "Needle Valve (Closed)",
    src: "./pid-symbols/NeedleValve(Closed).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img108",
    group: "Valves",
    category: "Ported Sleeve Valve",
    src: "./pid-symbols/PortedSleeveValve.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img109",
    group: "Valves",
    category: "Air Balancing Valve",
    src: "./pid-symbols/AirBalancingValve.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img110",
    group: "Valves",
    category: "Penstock (Open)",
    src: "./pid-symbols/Penstock(Open).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img111",
    group: "Valves",
    category: "Penstock (Closed)",
    src: "./pid-symbols/Penstock(Closed).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img112",
    group: "Valves",
    category: "Flap Valve",
    src: "./pid-symbols/FlapValve.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img113",
    group: "Valves",
    category: "Stop Log (Removed)",
    src: "./pid-symbols/StopLog(Removed).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img114",
    group: "Valves",
    category: "Stop Log (Inserted)",
    src: "./pid-symbols/StopLog(Inserted).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img115",
    group: "Valves",
    category: "Non-Return Valve",
    src: "./pid-symbols/Non-ReturnValve.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img116",
    group: "Valves",
    category: "Double Non-Return Valve",
    src: "./pid-symbols/DoubleNon-ReturnValve.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img117",
    group: "Valves",
    category: "Pressure Reducing Valve",
    src: "./pid-symbols/PressureReducingValve.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img118",
    group: "Valves",
    category: "Pressure Loading Valve",
    src: "./pid-symbols/PressureLoadingValve.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img119",
    group: "Valves",
    category: "Flow Restrictor - Fixed",
    src: "./pid-symbols/FlowRestrictor-Fixed.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img120",
    group: "Valves",
    category: "Flow Restrictor - Variable",
    src: "./pid-symbols/FlowRestrictor-Variable.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img121",
    group: "Valves",
    category: "Rotary Feeder Valve",
    src: "./pid-symbols/RotaryFeederValve.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img122",
    group: "Valves",
    category: "Air Release Valve (Large Orifice)",
    src: "./pid-symbols/AirReleaseValve(L).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img123",
    group: "Valves",
    category: "Air Release Valve (Small Orifice)",
    src: "./pid-symbols/AirReleaseValve(S).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img124",
    group: "Valves",
    category: "Air Release Valve (Dual Orifice)",
    src: "./pid-symbols/AirReleaseValve(D).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img125",
    group: "Valves",
    category: "Steam Trap",
    src: "./pid-symbols/SteamTrap.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img126",
    group: "Valves",
    category: "Condensate Release Valve",
    src: "./pid-symbols/CondensateReleaseValve.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img127",
    group: "Valves",
    category: "Hydrant Valve",
    src: "./pid-symbols/HydrantValve.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img128",
    group: "Valves",
    category: "Angle Valve (Open)",
    src: "./pid-symbols/AngleValve(Open).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img129",
    group: "Valves",
    category: "Angle Valve (Closed)",
    src: "./pid-symbols/AngleValve(Closed).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img130",
    group: "Valves",
    category: "Angle Pressure Relief",
    src: "./pid-symbols/AnglePressureRelief.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img131",
    group: "Valves",
    category: "Angle Vacuum Relief",
    src: "./pid-symbols/AngleVacuumRelief.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img132",
    group: "Valves",
    category: "3-Way Valve - L Port (Right Open)",
    src: "./pid-symbols/3-WayValve-LPort(RightOpen).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img133",
    group: "Valves",
    category: "3-Way Valve - L Port (Left Open)",
    src: "./pid-symbols/3-WayValve-LPort(LeftOpen).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img134",
    group: "Valves",
    category: "3-Way Plug Valve - L Port (Left Open)",
    src: "./pid-symbols/3-WayPlugValve-LPort(LeftOpen).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img135",
    group: "Valves",
    category: "3-Way Plug Valve - L Port (Right Open)",
    src: "./pid-symbols/3-WayPlugValve-LPort(RightOpen).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img136",
    group: "Valves",
    category: "3-Way Valve - T Port (Open)",
    src: "./pid-symbols/3-WayValve-TPort(Open).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img137",
    group: "Valves",
    category: "3-Way Valve - T Port (Right Open)",
    src: "./pid-symbols/3-WayValve-TPort(RightOpen).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img138",
    group: "Valves",
    category: "3-Way Valve - T Port (Left Open)",
    src: "./pid-symbols/3-WayValve-TPort(LeftOpen).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img139",
    group: "Valves",
    category: "3-Way Plug Valve - T Port (Open)",
    src: "./pid-symbols/3-WayPlugValve-TPort(Open).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img140",
    group: "Valves",
    category: "3-Way Plug Valve - T Port (Right Open)",
    src: "./pid-symbols/3-WayPlugValve-TPort(RightOpen).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img141",
    group: "Valves",
    category: "3-Way Plug Valve - T Port (Left Open)",
    src: "./pid-symbols/3-WayPlugValve-TPort(LeftOpen).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img142",
    group: "Valves",
    category: "4-Way Valve",
    src: "./pid-symbols/4-WayValve.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img143",
    group: "Valves",
    category: "General Valve (Open) - Existing",
    src: "./pid-symbols/GeneralValve(Open)-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img144",
    group: "Valves",
    category: "General Valve (Closed) - Existing",
    src: "./pid-symbols/GeneralValve(Closed)-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img145",
    group: "Valves",
    category: "Butterfly Valve (Open) - Existing",
    src: "./pid-symbols/ButterflyValve(Open)-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img146",
    group: "Valves",
    category: "Butterfly Valve (Closed) - Existing",
    src: "./pid-symbols/ButterflyValve(Closed)-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img147",
    group: "Valves",
    category: "Ball Valve (Open) - Existing",
    src: "./pid-symbols/BallValve(Open)-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img148",
    group: "Valves",
    category: "Ball Valve (Closed) - Existing",
    src: "./pid-symbols/BallValve(Closed)-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img149",
    group: "Valves",
    category: "Globe Valve (Open) - Existing",
    src: "./pid-symbols/GlobeValve(Open)-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img150",
    group: "Valves",
    category: "Globe Valve (Closed) - Existing",
    src: "./pid-symbols/GlobeValve(Closed)-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img151",
    group: "Valves",
    category: "Plug Valve (Open) - Existing",
    src: "./pid-symbols/PlugValve(Open)-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img152",
    group: "Valves",
    category: "Plug Valve (Closed) - Existing",
    src: "./pid-symbols/PlugValve(Closed)-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img153",
    group: "Valves",
    category: "Gate Valve (Open) - Existing",
    src: "./pid-symbols/GateValve(Open)-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img154",
    group: "Valves",
    category: "Gate Valve (Closed) - Existing",
    src: "./pid-symbols/GateValve(Closed)-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img155",
    group: "Valves",
    category: "Parallel Slide Valve (Open) - Existing",
    src: "./pid-symbols/ParallelSlideValve(Open)-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img156",
    group: "Valves",
    category: "Parallel Slide Valve (Closed) - Existing",
    src: "./pid-symbols/ParallelSlideValve(Closed)-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img157",
    group: "Valves",
    category: "Penstock (Open) - Existing",
    src: "./pid-symbols/Penstock(Open)-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img158",
    group: "Valves",
    category: "Penstock (Closed) - Existing",
    src: "./pid-symbols/Penstock(Closed)-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img159",
    group: "Valves",
    category: "Non-Return Valve - Existing",
    src: "./pid-symbols/Non-ReturnValve-Existing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img160",
    group: "Valve Operators",
    category: "Manual Isolation",
    src: "./pid-symbols/ManualIsolation.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img161",
    group: "Valve Operators",
    category: "Rotary Motor",
    src: "./pid-symbols/RotaryMotor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img162",
    group: "Valve Operators",
    category: "Piston",
    src: "./pid-symbols/Piston.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img163",
    group: "Valve Operators",
    category: "Solenoid",
    src: "./pid-symbols/Solenoid.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img164",
    group: "Valve Operators",
    category: "Dash Pot Checked",
    src: "./pid-symbols/DashPotChecked.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img165",
    group: "Valve Operators",
    category: "Diaphragm - Pressure Balance",
    src: "./pid-symbols/Diaphragm-PressureBalance.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img166",
    group: "Valve Operators",
    category: "Diaphragm",
    src: "./pid-symbols/Diaphragm.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img167",
    group: "Valve Operators",
    category: "Draphragm - Pressure Regulator with Internal Tap",
    src: "./pid-symbols/Draphragm-PressureRegulatorwithInternalTap.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img168",
    group: "Valve Operators",
    category: "Float",
    src: "./pid-symbols/Float.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img169",
    group: "Valve Operators",
    category: "Weight Loaded",
    src: "./pid-symbols/WeightLoaded.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img170",
    group: "Valve Operators",
    category: "Spring",
    src: "./pid-symbols/Spring.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img171",
    group: "Valve Operators",
    category: "Statically Loaded",
    src: "./pid-symbols/StaticallyLoaded.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img172",
    group: "Valve Operators",
    category: "Automatic Actuation Element",
    src: "./pid-symbols/AutomaticActuationElement.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img173",
    group: "Valve Operators",
    category: "Automatic Actuation Element Opens On Failure",
    src: "./pid-symbols/AutomaticActuationElementOpensOnFailure.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img174",
    group: "Valve Operators",
    category: "Automatic Actuation Element Closes On Failure",
    src: "./pid-symbols/AutomaticActuationElementClosesOnFailure.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img175",
    group: "Valve Operators",
    category: "Automatic Actuation Element Quick Opening",
    src: "./pid-symbols/AutomaticActuationElementQuickOpening.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img176",
    group: "Valve Operators",
    category: "Automatic Actuation Element Quick Closing",
    src: "./pid-symbols/AutomaticActuationElementQuickClosing.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img177",
    group: "Valve Operators",
    category: "Automatic Actuation Element Retains Position On Failure",
    src: "./pid-symbols/AutomaticActuationElementRetainsPositionOnFailure.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img178",
    group: "Valve Operators",
    category:
      "Automatic Actuation Element Retains Position On Failure Safe Drift Open",
    src: "./pid-symbols/AutomaticActuationElementRetainsPositionOnFailureSafeDriftOpen.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img179",
    group: "Valve Operators",
    category:
      "Automatic Actuation Element Retains Position On Failure Safe Drift Closed",
    src: "./pid-symbols/AutomaticActuationElementRetainsPositionOnFailureSafeDriftClosed.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img180",
    group: "Pipeline Symbols",
    category: "Closed End - Welded",
    src: "./pid-symbols/ClosedEnd-Welded.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img181",
    group: "Pipeline Symbols",
    category: "Closed End - Screwed",
    src: "./pid-symbols/ClosedEnd-Screwed.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img182",
    group: "Pipeline Symbols",
    category: "Closed End - Flanged",
    src: "./pid-symbols/ClosedEnd-Flanged.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img183",
    group: "Pipeline Symbols",
    category: "Closed End - Quick Release",
    src: "./pid-symbols/ClosedEnd-QuickRelease.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img184",
    group: "Pipeline Symbols",
    category: "Hose Coupling",
    src: "./pid-symbols/HoseCoupling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img185",
    group: "Pipeline Symbols",
    category: "Bauer Connection",
    src: "./pid-symbols/BauerConnection.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img186",
    group: "Pipeline Symbols",
    category: "Discharge to Atmosphere",
    src: "./pid-symbols/DischargetoAtmosphere.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img187",
    group: "Pipeline Symbols",
    category: "Intake to Atmosphere",
    src: "./pid-symbols/IntaketoAtmosphere.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img188",
    group: "Pipeline Symbols",
    category: "Bell Mouth",
    src: "./pid-symbols/BellMouth.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img189",
    group: "Pipeline Symbols",
    category: "Manually Adjustable Bell Mouth",
    src: "./pid-symbols/ManuallyAdjustableBellMouth.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img190",
    group: "Pipeline Symbols",
    category: "Motorised Adjustable Bell Mouth",
    src: "./pid-symbols/MotorisedAdjustableBellMouth.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img191",
    group: "Pipeline Symbols",
    category: "Drain Tundish",
    src: "./pid-symbols/DrainTundish.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img192",
    group: "Pipeline Symbols",
    category: "Lagging (Thermal)",
    src: "./pid-symbols/Lagging(Thermal).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img193",
    group: "Pipeline Symbols",
    category: "Lagging (Heat Tracing)",
    src: "./pid-symbols/Lagging(HeatTracing).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img194",
    group: "Pipeline Symbols",
    category: "In-Line Flanges",
    src: "./pid-symbols/In-LineFlanges.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img195",
    group: "Pipeline Symbols",
    category: "Orifice Plate",
    src: "./pid-symbols/OrificePlate.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img196",
    group: "Pipeline Symbols",
    category: "In-Line Spade",
    src: "./pid-symbols/In-LineSpade.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img197",
    group: "Pipeline Symbols",
    category: "In-Line Spacer",
    src: "./pid-symbols/In-LineSpacer.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img198",
    group: "Pipeline Symbols",
    category: "Spectacle Blind Open",
    src: "./pid-symbols/SpectacleBlindOpen.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img199",
    group: "Pipeline Symbols",
    category: "Spectacle Blind Closed",
    src: "./pid-symbols/SpectacleBlindClosed.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img200",
    group: "Pipeline Symbols",
    category: "Rodding Point",
    src: "./pid-symbols/RoddingPoint.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img201",
    group: "Pipeline Symbols",
    category: "Reducer",
    src: "./pid-symbols/Reducer.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img202",
    group: "Pipeline Symbols",
    category: "In-Line Coupling",
    src: "./pid-symbols/In-LineCoupling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img203",
    group: "Pipeline Symbols",
    category: "Outfall",
    src: "./pid-symbols/Outfall.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img204",
    group: "Pipeline Symbols",
    category: "Grill/Diffuser",
    src: "./pid-symbols/GrillDiffuser.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img205",
    group: "Pipeline Symbols",
    category: "Expansion Loop",
    src: "./pid-symbols/ExpansionLoop.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img206",
    group: "Inline Equipment",
    category: "Filter     /     Strainer",
    src: "./pid-symbols/FilterStrainer.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img207",
    group: "Inline Equipment",
    category: "Duplex Filter     /     Strainer",
    src: "./pid-symbols/DuplexFilterStrainer.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img208",
    group: "Inline Equipment",
    category: "Flexible Hose",
    src: "./pid-symbols/FlexibleHose.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img209",
    group: "Inline Equipment",
    category: "Bellows",
    src: "./pid-symbols/Bellows.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img210",
    group: "Inline Equipment",
    category: "Extension Sleeve",
    src: "./pid-symbols/ExtensionSleeve.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img211",
    group: "Inline Equipment",
    category: "Bursting Disc",
    src: "./pid-symbols/BurstingDisc.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img212",
    group: "Inline Equipment",
    category: "Anti Syphon Device",
    src: "./pid-symbols/AntiSyphonDevice.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img213",
    group: "Inline Equipment",
    category: "Pipe Interuptor",
    src: "./pid-symbols/PipeInteruptor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img214",
    group: "Inline Equipment",
    category: "Pulsation Damper",
    src: "./pid-symbols/PulsationDamper.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img215",
    group: "Inline Equipment",
    category: "Bubble Trap",
    src: "./pid-symbols/BubbleTrap.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img216",
    group: "Inline Equipment",
    category: "Silencer",
    src: "./pid-symbols/Silencer.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img217",
    group: "Inline Equipment",
    category: "Flume",
    src: "./pid-symbols/Flume.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img218",
    group: "Inline Equipment",
    category: "Flame Arrestor",
    src: "./pid-symbols/FlameArrestor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img219",
    group: "Inline Equipment",
    category: "Weir",
    src: "./pid-symbols/Weir.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img220",
    group: "Inline Equipment",
    category: "Ejector     /     Injector",
    src: "./pid-symbols/EjectorInjector.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img221",
    group: "Inline Equipment",
    category: "Calibration Pot",
    src: "./pid-symbols/CalibrationPot.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img222",
    group: "Inline Equipment",
    category: "Hydrobrake",
    src: "./pid-symbols/Hydrobrake.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img223",
    group: "Instruments",
    category: "General",
    src: "./pid-symbols/General.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img224",
    group: "Instruments",
    category: "General With Mechanical Indicator",
    src: "./pid-symbols/GeneralWithMechanicalIndicator.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img225",
    group: "Instruments",
    category: "Level - General",
    src: "./pid-symbols/Level-General.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Sensor Mount Type",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img226",
    group: "Instruments",
    category: "Level - Float",
    src: "./pid-symbols/Level-Float.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Sensor Mount Type",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img227",
    group: "Instruments",
    category: "Level - Electrode (Capacitive)",
    src: "./pid-symbols/Level-Electrode(Capacitive).png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Sensor Mount Type",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img228",
    group: "Instruments",
    category: "Level - Electrode (Conductive)",
    src: "./pid-symbols/Level-Electrode(Conductive).png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Sensor Mount Type",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img229",
    group: "Instruments",
    category: "Level - Resistance (Strain Gauge)",
    src: "./pid-symbols/Level-Resistance(StrainGauge).png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Sensor Mount Type",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img230",
    group: "Instruments",
    category: "Level - Membrane (Diaphragm)",
    src: "./pid-symbols/Level-Membrane(Diaphragm).png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Sensor Mount Type",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img231",
    group: "Instruments",
    category: "Level - Ultrasonic",
    src: "./pid-symbols/Level-Ultrasonic.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Sensor Mount Type",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img232",
    group: "Instruments",
    category: "Level - Sight Glass (Tank Level)",
    src: "./pid-symbols/Level-SightGlass(TankLevel).png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Sensor Mount Type",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img233",
    group: "Instruments",
    category: "Level - Displacer",
    src: "./pid-symbols/Level-Displacer.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Sensor Mount Type",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img234",
    group: "Instruments",
    category: "Flow - General",
    src: "./pid-symbols/Flow-General.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img235",
    group: "Instruments",
    category: "Flow - Orifice Plate",
    src: "./pid-symbols/Flow-OrificePlate.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img236",
    group: "Instruments",
    category: "Flow - Pitot Tube",
    src: "./pid-symbols/Flow-PitotTube.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img237",
    group: "Instruments",
    category: "Flow - Venturi Tube",
    src: "./pid-symbols/Flow-VenturiTube.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img238",
    group: "Instruments",
    category: "Flow - Turbine     /     Rotary",
    src: "./pid-symbols/Flow-TurbineRotary.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img239",
    group: "Instruments",
    category: "Flow - Rotary Displacement",
    src: "./pid-symbols/Flow-RotaryDisplacement.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img240",
    group: "Instruments",
    category: "Flow - Electromagnetic",
    src: "./pid-symbols/Flow-Electromagnetic.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img241",
    group: "Instruments",
    category: "Flow - Variable Area",
    src: "./pid-symbols/Flow-VariableArea.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img242",
    group: "Instruments",
    category: "Flow - Flow Nozzle",
    src: "./pid-symbols/Flow-FlowNozzle.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img243",
    group: "Instruments",
    category: "Flow - Sight Glass",
    src: "./pid-symbols/Flow-SightGlass.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "Transmitter Mounting Location",
    StaticProps7: "",
  },
  {
    id: "img244",
    group: "Instruments",
    category: "Pressure",
    src: "./pid-symbols/Pressure.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img245",
    group: "Instruments",
    category: "Pressure With Mechanical Indicator",
    src: "./pid-symbols/PressureWithMechanicalIndicator.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img246",
    group: "Instruments",
    category: "Pressure Differential",
    src: "./pid-symbols/PressureDifferential.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "Size (NB or OD) (mm or inches)",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img247",
    group: "Instruments",
    category: "Temperature",
    src: "./pid-symbols/Temperature.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img248",
    group: "Instruments",
    category: "Temperature With Mechanical Indicator",
    src: "./pid-symbols/TemperatureWithMechanicalIndicator.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img249",
    group: "Instruments",
    category: "Quality - General",
    src: "./pid-symbols/Quality-General.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img250",
    group: "Instruments",
    category: "Quality - Multifunction",
    src: "./pid-symbols/Quality-Multifunction.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img251",
    group: "Instruments",
    category: "Quality - Conductivity",
    src: "./pid-symbols/Quality-Conductivity.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img252",
    group: "Instruments",
    category: "Quality - Free Chlorine",
    src: "./pid-symbols/Quality-FreeChlorine.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img253",
    group: "Instruments",
    category: "Quality - Total Chlorine",
    src: "./pid-symbols/Quality-TotalChlorine.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img254",
    group: "Instruments",
    category: "Quality - Iron",
    src: "./pid-symbols/Quality-Iron.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img255",
    group: "Instruments",
    category: "Quality - Turbidity",
    src: "./pid-symbols/Quality-Turbidity.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img256",
    group: "Instruments",
    category: "Quality - Ultra-Violet Transmissivity",
    src: "./pid-symbols/Quality-Ultra-VioletTransmissivity.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img257",
    group: "Instruments",
    category: "Quality - Dissolved Oxygen",
    src: "./pid-symbols/Quality-DissolvedOxygen.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img258",
    group: "Instruments",
    category: "Quality - Acidity",
    src: "./pid-symbols/Quality-Acidity.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img259",
    group: "Instruments",
    category: "Quality - Nitrates",
    src: "./pid-symbols/Quality-Nitrates.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img260",
    group: "Instruments",
    category: "Quality - Ammonia",
    src: "./pid-symbols/Quality-Ammonia.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img261",
    group: "Instruments",
    category: "Quality - Phosphates",
    src: "./pid-symbols/Quality-Phosphates.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img262",
    group: "Instruments",
    category: "Quality - Suspended Solids",
    src: "./pid-symbols/Quality-SuspendedSolids.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img263",
    group: "Instruments",
    category: "Quality - Fluoride",
    src: "./pid-symbols/Quality-Fluoride.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img264",
    group: "Instruments",
    category: "Quality - Aluminium",
    src: "./pid-symbols/Quality-Aluminium.png",
    StaticProps1: "Instrument Type",
    StaticProps2: "",
    StaticProps3: "Process Range - Maximum",
    StaticProps4: "Process Range - Minimum",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img265",
    group: "Instruments",
    category: "Instrument Tag (Field Mounted)",
    src: "./pid-symbols/InstrumentTag(FieldMounted).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img266",
    group: "Instruments",
    category: "Instrument Tag (Local Panel Mounted)",
    src: "./pid-symbols/InstrumentTag(LocalPanelMounted).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img267",
    group: "Instruments",
    category: "Instrument Tag (Main Panel Mounted)",
    src: "./pid-symbols/InstrumentTag(MainPanelMounted).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img268",
    group: "Instruments",
    category: "Control Panel (Field Mounted)",
    src: "./pid-symbols/ControlPanel(FieldMounted).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img269",
    group: "Instruments",
    category: "Control Panel (Local)",
    src: "./pid-symbols/ControlPanel(Local).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img270",
    group: "Instruments",
    category: "Control Panel (Main)",
    src: "./pid-symbols/ControlPanel(Main).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img271",
    group: "Instruments",
    category: "Warning Siren",
    src: "./pid-symbols/WarningSiren.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img272",
    group: "Instruments",
    category: "Warning Light",
    src: "./pid-symbols/WarningLight.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img273",
    group: "Instruments",
    category: "Antenna",
    src: "./pid-symbols/Antenna.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img274",
    group: "Tanks/Vessels",
    category: "Open Tank",
    src: "./pid-symbols/OpenTank.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img275",
    group: "Tanks/Vessels",
    category: "Closed Tank With Vent",
    src: "./pid-symbols/ClosedTankWithVent.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img276",
    group: "Tanks/Vessels",
    category: "Covered Tank",
    src: "./pid-symbols/CoveredTank.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img277",
    group: "Tanks/Vessels",
    category: "Covered Tank with Sloped Base",
    src: "./pid-symbols/CoveredTankwithSlopedBase.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img278",
    group: "Tanks/Vessels",
    category: "Storage Tank",
    src: "./pid-symbols/StorageTank.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img279",
    group: "Tanks/Vessels",
    category: "Closed Tank with Sealed Manway",
    src: "./pid-symbols/ClosedTankwithSealedManway.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img280",
    group: "Tanks/Vessels",
    category: "Storage Hopper     /     Silo",
    src: "./pid-symbols/StorageHopperSilo.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img281",
    group: "Tanks/Vessels",
    category: "Storage Hopper     /     Silo with Vibrator",
    src: "./pid-symbols/StorageHopperSilowithVibrator.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img282",
    group: "Tanks/Vessels",
    category: "Skip/Bin",
    src: "./pid-symbols/SkipBin.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img283",
    group: "Tanks/Vessels",
    category: "Dessicant Drier",
    src: "./pid-symbols/DessicantDrier.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img284",
    group: "Tanks/Vessels",
    category: "Gas Holder",
    src: "./pid-symbols/GasHolder.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img285",
    group: "Tanks/Vessels",
    category: "Digestor",
    src: "./pid-symbols/Digestor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img286",
    group: "Tanks/Vessels",
    category: "Degassing Tower",
    src: "./pid-symbols/DegassingTower.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img287",
    group: "Tanks/Vessels",
    category: "Saturator",
    src: "./pid-symbols/Saturator.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img288",
    group: "Tanks/Vessels",
    category: "Air Receiver     /     Drum",
    src: "./pid-symbols/AirReceiverDrum.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img289",
    group: "Tanks/Vessels",
    category: "Detritor",
    src: "./pid-symbols/Detritor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img290",
    group: "Tanks/Vessels",
    category: "Dorr Type Detritor",
    src: "./pid-symbols/DorrTypeDetritor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img291",
    group: "Tanks/Vessels",
    category: "Settlement Tank Conical Bottom",
    src: "./pid-symbols/SettlementTankConicalBottom.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img292",
    group: "Tanks/Vessels",
    category: "Peripheral Drive 1     /     2 Bridge",
    src: "./pid-symbols/PeripheralDrive12Bridge.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img293",
    group: "Tanks/Vessels",
    category: "Central Drive Full Bridge",
    src: "./pid-symbols/CentralDriveFullBridge.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img294",
    group: "Tanks/Vessels",
    category: "Settlement Tank Flat Bottom",
    src: "./pid-symbols/SettlementTankFlatBottom.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img295",
    group: "Tanks/Vessels",
    category: "Central Drive Picket Fence Thickener",
    src: "./pid-symbols/CentralDrivePicketFenceThickener.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img296",
    group: "Tanks/Vessels",
    category: "Central Drive WRC Thickener",
    src: "./pid-symbols/CentralDriveWRCThickener.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img297",
    group: "Tanks/Vessels",
    category: "Floating Draw Off Arm",
    src: "./pid-symbols/FloatingDrawOffArm.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img298",
    group: "Tanks/Vessels",
    category: "XDS Type Clarifier",
    src: "./pid-symbols/XDSTypeClarifier.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img299",
    group: "Tanks/Vessels",
    category: "SR Type Clarifier",
    src: "./pid-symbols/SRTypeClarifier.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img300",
    group: "Tanks/Vessels",
    category: "Hopper Bottom Sludge Blanket Clarifier (Square)",
    src: "./pid-symbols/HopperBottomSludgeBlanketClarifier(Square).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img301",
    group: "Tanks/Vessels",
    category: "Flat Bottom Sludge Blanket Clarifier (Square)",
    src: "./pid-symbols/FlatBottomSludgeBlanketClarifier(Square).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img302",
    group: "Tanks/Vessels",
    category: "Lamella Hopper",
    src: "./pid-symbols/LamellaHopper.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img303",
    group: "Tanks/Vessels",
    category: "Dissolved Air Floatation",
    src: "./pid-symbols/DissolvedAirFloatation.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img304",
    group: "Tanks/Vessels",
    category: "Aeration - Horizontal Surface",
    src: "./pid-symbols/Aeration-HorizontalSurface.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img305",
    group: "Tanks/Vessels",
    category: "Aeration - Jet",
    src: "./pid-symbols/Aeration-Jet.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img306",
    group: "Tanks/Vessels",
    category: "Aeration - Fine Bubble Diffused Air",
    src: "./pid-symbols/Aeration-FineBubbleDiffusedAir.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img307",
    group: "Tanks/Vessels",
    category: "Aeration - Coarse Bubble Diffused Air",
    src: "./pid-symbols/Aeration-CoarseBubbleDiffusedAir.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img308",
    group: "Tanks/Vessels",
    category: "Aeration - Vertical Surface",
    src: "./pid-symbols/Aeration-VerticalSurface.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img309",
    group: "Tanks/Vessels",
    category: "Nozzle Diffuser Plant - Dome",
    src: "./pid-symbols/NozzleDiffuserPlant-Dome.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img310",
    group: "Tanks/Vessels",
    category: "Nozzle Diffuse Plant - Disc",
    src: "./pid-symbols/NozzleDiffusePlant-Disc.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img311",
    group: "Tanks/Vessels",
    category: "Lamella Separator with Zickert Type Scrapper System",
    src: "./pid-symbols/LamellaSeparatorwithZickertTypeScrapperSystem.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img312",
    group: "Tanks/Vessels",
    category: "Rapid Gravity Filter",
    src: "./pid-symbols/RapidGravityFilter.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img313",
    group: "Tanks/Vessels",
    category: "Bicarbone Filter",
    src: "./pid-symbols/BicarboneFilter.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img314",
    group: "Tanks/Vessels",
    category: "Filtromatic Filter",
    src: "./pid-symbols/FiltromaticFilter.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img315",
    group: "Tanks/Vessels",
    category: "Rotary Vacuum Filter",
    src: "./pid-symbols/RotaryVacuumFilter.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img316",
    group: "Tanks/Vessels",
    category: "RO Stack",
    src: "./pid-symbols/ROStack.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img317",
    group: "Tanks/Vessels",
    category: "Vertical Pressure Filter",
    src: "./pid-symbols/VerticalPressureFilter.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img318",
    group: "Tanks/Vessels",
    category: "Horizontal Pressure Filter",
    src: "./pid-symbols/HorizontalPressureFilter.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img319",
    group: "Tanks/Vessels",
    category: "Trickling Filter (Rock Media)",
    src: "./pid-symbols/TricklingFilter(RockMedia).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img320",
    group: "Tanks/Vessels",
    category: "Trickling Filter (Plastic Structured Media)",
    src: "./pid-symbols/TricklingFilter(PlasticStructuredMedia).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img321",
    group: "Tanks/Vessels",
    category: "Oil Separator",
    src: "./pid-symbols/OilSeparator.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img322",
    group: "Tanks/Vessels",
    category: "Cholrine Bottle",
    src: "./pid-symbols/CholrineBottle.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img323",
    group: "Grit Handling",
    category: "CV Grit Channel Travelling Pump",
    src: "./pid-symbols/CVGritChannelTravellingPump.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img324",
    group: "Grit Handling",
    category: "Grit Classifier Reciprocating Rake",
    src: "./pid-symbols/GritClassifierReciprocatingRake.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img325",
    group: "Grit Handling",
    category: "Grit Classifier Screw",
    src: "./pid-symbols/GritClassifierScrew.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img326",
    group: "Grit Handling",
    category: "Grit Classifier Vortex (Cyclone or Hyrdocyclone)",
    src: "./pid-symbols/GritClassifietVortex(CycloneorHyrdocyclone).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img327",
    group: "Presses",
    category: "Hydropress",
    src: "./pid-symbols/Hydropress.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img328",
    group: "Presses",
    category: "Filter Press",
    src: "./pid-symbols/FilterPress.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img329",
    group: "Presses",
    category: "Belt Press",
    src: "./pid-symbols/BeltPress.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img330",
    group: "Presses",
    category: "Centrifuge With Common Bowl and Scroll Drive",
    src: "./pid-symbols/CentrifugeWithCommonBowlandScrollDrive.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img331",
    group: "Presses",
    category: "Gravity Belt Thickener",
    src: "./pid-symbols/GravityBeltThickener.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img332",
    group: "Presses",
    category: "Compactor",
    src: "./pid-symbols/Compactor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img333",
    group: "Presses",
    category: "Washing Compactor",
    src: "./pid-symbols/WashingCompactor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img334",
    group: "Emergency Equipment",
    category: "Emergency Shower",
    src: "./pid-symbols/EmergencyShower.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img335",
    group: "Emergency Equipment",
    category: "Emergency Shower with Header Tank",
    src: "./pid-symbols/EmergencyShowerwithHeaderTank.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img336",
    group: "Emergency Equipment",
    category: "Emergency Eye Bath",
    src: "./pid-symbols/EmergencyEyeBath.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img337",
    group: "Emergency Equipment",
    category: "Hose Reel",
    src: "./pid-symbols/HoseReel.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img338",
    group: "Sample Equipment",
    category: "Universal Sample Module",
    src: "./pid-symbols/UniversalSampleModule.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img339",
    group: "Page Connectors & Demarcations",
    category: "Off Page Connector (Right)",
    src: "./pid-symbols/OffPageConnector(right).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img340",
    group: "Page Connectors & Demarcations",
    category: "Off Page Connector (Left)",
    src: "./pid-symbols/OffPageConnector(left).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img341",
    group: "Page Connectors & Demarcations",
    category: "Limit of Supply or Pipe Material Change",
    src: "./pid-symbols/LimitofSupplyorPipeMaterialChange.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img342",
    group: "Vehicles",
    category: "Road Tanker",
    src: "./pid-symbols/RoadTanker.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img343",
    group: "Vehicles",
    category: "Articulated Tipper Lorry Emptying",
    src: "./pid-symbols/ArticulatedTipperLorryEmptying.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img344",
    group: "Vehicles",
    category: "Articulated Tipper Lorry Filling From Silo",
    src: "./pid-symbols/ArticulatedTipperLorryFillingFromSilo.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img345",
    group: "Packaged Equipment",
    category: "General Packaged Equipment",
    src: "./pid-symbols/GeneralPackagedEquipment.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img346",
    group: "WNI Assemblies",
    category: "Aeration Tower",
    src: "./pid-symbols/AerationTower.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img347",
    group: "WNI Assemblies",
    category: "Ammonia Combined Drains Sampling",
    src: "./pid-symbols/AmmoniaCombinedDrainsSampling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img348",
    group: "WNI Assemblies",
    category: "Ammonia Separate Drains Sampling",
    src: "./pid-symbols/AmmoniaSeparateDrainsSampling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img349",
    group: "WNI Assemblies",
    category: "Blower Arrangement",
    src: "./pid-symbols/BlowerArrangement.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img350",
    group: "WNI Assemblies",
    category: "Chemical Dosing Static Mixer",
    src: "./pid-symbols/ChemicalDosingStaticMixer.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img351",
    group: "WNI Assemblies",
    category: "Free Chlorine Sampling",
    src: "./pid-symbols/FreeChlorineSampling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img352",
    group: "WNI Assemblies",
    category: "Iron Combined Drains Sampling",
    src: "./pid-symbols/IronCombinedDrainsSampling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img353",
    group: "WNI Assemblies",
    category: "Iron Separate Drains Sampling",
    src: "./pid-symbols/IronSeparateDrainsSampling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img354",
    group: "WNI Assemblies",
    category: "Manual Sampling",
    src: "./pid-symbols/ManualSampling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img355",
    group: "WNI Assemblies",
    category: "pH Monitor Sampling",
    src: "./pid-symbols/pHMonitorSampling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img356",
    group: "WNI Assemblies",
    category: "Phosphate Combined Drains Sampling",
    src: "./pid-symbols/PhosphateCombinedDrainsSampling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img357",
    group: "WNI Assemblies",
    category: "Phosphate Separate Drains Sampling",
    src: "./pid-symbols/PhosphateSeparateDrainsSampling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img358",
    group: "WNI Assemblies",
    category: "Sample Pump Arrangement",
    src: "./pid-symbols/SamplePumpArrangement.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img359",
    group: "WNI Assemblies",
    category: "Sampling Kiosk",
    src: "./pid-symbols/SamplingKiosk.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img360",
    group: "WNI Assemblies",
    category: "Standard Pressure Tapping With Mono Block Valve",
    src: "./pid-symbols/StandardPressureTappingWithMonoBlockValve.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img361",
    group: "WNI Assemblies",
    category: "Standard Pressure Tapping With Two Valves",
    src: "./pid-symbols/StandardPressureTappingWithTwoValves.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img362",
    group: "WNI Assemblies",
    category: "Standard Pump Arrangement",
    src: "./pid-symbols/StandardPumpArrangement.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img363",
    group: "WNI Assemblies",
    category: "Total Chlorine Sampling",
    src: "./pid-symbols/TotalChlorineSampling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img364",
    group: "WNI Assemblies",
    category: "Turbidity And Motor Sampling",
    src: "./pid-symbols/TurbidityAndMotorSampling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img365",
    group: "WNI Assemblies",
    category: "Turbidity Sampling",
    src: "./pid-symbols/TurbiditySampling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img366",
    group: "WNI Assemblies",
    category: "Turbidity With Bubble Trap And Motor Sampling",
    src: "./pid-symbols/TurbidityWithBubbleTrapAndMotorSampling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img367",
    group: "WNI Assemblies",
    category: "Turbidity With Bubble Trap Sampling",
    src: "./pid-symbols/TurbidityWithBubbleTrapSampling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img368",
    group: "WNI Assemblies",
    category: "UV Reactor",
    src: "./pid-symbols/UVReactor.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img369",
    group: "WNI Assemblies",
    category: "UV Transmissivity (Treatment)",
    src: "./pid-symbols/UVTransmissivity(Treatment).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img370",
    group: "WNI Assemblies",
    category: "UV Transmissivity Sampling",
    src: "./pid-symbols/UVTransmissivitySampling.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img371",
    group: "WNI Assemblies",
    category: "Venturi Aeration",
    src: "./pid-symbols/VenturiAeration.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img372",
    group: "WNI Assemblies",
    category: "Washwater Settlement Tank",
    src: "./pid-symbols/WashwaterSettlementTank.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img373",
    group: "WNI Assemblies",
    category: "UV in building",
    src: "./pid-symbols/UVBuilding.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img374",
    group: "WRNI Assemblies",
    category: "FST 23 Bridge Scraper With Spray Bar And Washout",
    src: "./pid-symbols/FST23BridgeScraperWithSprayBarAndWashout.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img375",
    group: "WRNI Assemblies",
    category: "FST Half Bridge Scraper",
    src: "./pid-symbols/FSTHalfBridgeScraper.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img376",
    group: "WRNI Assemblies",
    category: "FST Half Bridge Scraper With Spray Bar and Washout",
    src: "./pid-symbols/FSTHalfBridgeScraperWithSprayBarandWashOut.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img377",
    group: "WRNI Assemblies",
    category: "FST Half Bridge Scraper With Washout",
    src: "./pid-symbols/FSTHalfBridgeScraperWithWashout.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img378",
    group: "WRNI Assemblies",
    category: "Primary Humus 23 Bridge",
    src: "./pid-symbols/PrimaryHumus23Bridge.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img379",
    group: "WRNI Assemblies",
    category: "Primary Humus Half Bridge",
    src: "./pid-symbols/PrimaryHumusHalfBridge.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img380",
    group: "P Scheme Green Boxes",
    category: "Auto De-sludge Pump Skid No.1 Left",
    src: "./pid-symbols/AutoDeSludgePumpSkid1L.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img381",
    group: "P Scheme Green Boxes",
    category: "Auto De-sludge Pump Skid No.1 Right",
    src: "./pid-symbols/AutoDeSludgePumpSkid1R.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img382",
    group: "P Scheme Green Boxes",
    category: "Auto De-sludge Pump Skid No.2 Left",
    src: "./pid-symbols/AutoDeSludgePumpSkid2L.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img383",
    group: "P Scheme Green Boxes",
    category: "Auto De-sludge Pump Skid No.2 Right",
    src: "./pid-symbols/AutoDeSludgePumpSkid2R.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img384",
    group: "P Scheme Green Boxes",
    category: "Auto De-sludge Pump Skid No.3 Left",
    src: "./pid-symbols/AutoDeSludgePumpSkid3L.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img385",
    group: "P Scheme Green Boxes",
    category: "Auto De-sludge Pump Skid No.3 Right",
    src: "./pid-symbols/AutoDeSludgePumpSkid3R.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img386",
    group: "P Scheme Green Boxes",
    category: "Auto De-sludge Pump Skid No.4 Left",
    src: "./pid-symbols/AutoDeSludgePumpSkid4L.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img387",
    group: "P Scheme Green Boxes",
    category: "Auto De-sludge Pump Skid No.4 Right",
    src: "./pid-symbols/AutoDeSludgePumpSkid4R.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img388",
    group: "P Scheme Green Boxes",
    category: "Backwash Returns Pump Mono A2 - Tank height < 2.5 m",
    src: "./pid-symbols/BackwashReturnPumpMonoA2.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img389",
    group: "P Scheme Green Boxes",
    category: "Backwash Returns Pump Mono A2 - Tank height > 2.5 m",
    src: "./pid-symbols/BackwashReturnPumpMonoA2H.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img390",
    group: "P Scheme Green Boxes",
    category: "Backwash Returns Pump Mono B - Tank height < 2.5 m",
    src: "./pid-symbols/BackwashReturnPumpMonoB.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img391",
    group: "P Scheme Green Boxes",
    category: "Backwash Returns Pump Mono B - Tank height > 2.5 m",
    src: "./pid-symbols/BackwashReturnPumpMonoBH.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img392",
    group: "P Scheme Green Boxes",
    category: "Chemical Dosing Package - Lintott - 1 Dosing Pump",
    src: "./pid-symbols/ChemicalDosingPackageLintott1Pump.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img393",
    group: "P Scheme Green Boxes",
    category: "Chemical Dosing Package - Lintott - 2 Dosing Pumps",
    src: "./pid-symbols/ChemicalDosingPackageLintott2Pumps.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img394",
    group: "P Scheme Green Boxes",
    category: "Chemical Dosing Package - Lintott - 3 Dosing Pumps",
    src: "./pid-symbols/ChemicalDosingPackageLintott3Pumps.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img395",
    group: "P Scheme Green Boxes",
    category: "Chemical Dosing Package - Lintott - 4 Dosing Pumps",
    src: "./pid-symbols/ChemicalDosingPackageLintott4Pumps.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img396",
    group: "P Scheme Green Boxes",
    category: "Dose Point Mixing for Blower 1 R20",
    src: "./pid-symbols/DosePointMixingBlower1R20.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img397",
    group: "P Scheme Green Boxes",
    category: "Dose Point Mixing for Blower 1 R30",
    src: "./pid-symbols/DosePointMixingBlower1R30.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img398",
    group: "P Scheme Green Boxes",
    category: "Dose Point Mixing for Blower 1 R40",
    src: "./pid-symbols/DosePointMixingBlower1R40.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img399",
    group: "P Scheme Green Boxes",
    category: "Dose Point Mixing for Blower 2 R20",
    src: "./pid-symbols/DosePointMixingBlower2R20.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img400",
    group: "P Scheme Green Boxes",
    category: "Dose Point Mixing for Blower 2 R30",
    src: "./pid-symbols/DosePointMixingBlower2R30.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img401",
    group: "P Scheme Green Boxes",
    category: "Dose Point Mixing for Blower 2 R40",
    src: "./pid-symbols/DosePointMixingBlower2R40.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img402",
    group: "P Scheme Green Boxes",
    category: "Dose Point Mixing for MONO pump 1",
    src: "./pid-symbols/DosePointMixingMONOPump1.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img403",
    group: "P Scheme Green Boxes",
    category: "Dose Point Mixing for MONO pump 2",
    src: "./pid-symbols/DosePointMixingMONOPump2.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img404",
    group: "P Scheme Green Boxes",
    category: "Emergency Shower - CCP010 - with potable water connection",
    src: "./pid-symbols/EmergencyShowerA.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img405",
    group: "P Scheme Green Boxes",
    category: "Emergency Shower - LCP015 - with potable water connection",
    src: "./pid-symbols/EmergencyShowerB.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img406",
    group: "P Scheme Green Boxes",
    category: "Emergency Shower - CCP020 - with potable water connection",
    src: "./pid-symbols/EmergencyShowerC.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img407",
    group: "P Scheme Green Boxes",
    category: "Emergency Shower - No Potable water connection",
    src: "./pid-symbols/EmergencyShowerD.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img408",
    group: "P Scheme Green Boxes",
    category: "Rapid Mixing Chamber and Two Flocculators",
    src: "./pid-symbols/MixingAndFlocculationTank.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img409",
    group: "P Scheme Green Boxes",
    category: "Actuated bellmouth desludge PST or FST No.1",
    src: "./pid-symbols/PSTDesludgeValve1.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img410",
    group: "P Scheme Green Boxes",
    category: "Actuated bellmouth desludge PST or FST No.2",
    src: "./pid-symbols/PSTDesludgeValve2.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img411",
    group: "P Scheme Green Boxes",
    category: "Actuated bellmouth desludge PST or FST No.3",
    src: "./pid-symbols/PSTDesludgeValve3.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img412",
    group: "P Scheme Green Boxes",
    category: "Actuated bellmouth desludge PST or FST No.4",
    src: "./pid-symbols/PSTDesludgeValve4.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img413",
    group: "P Scheme Green Boxes",
    category: "Screen",
    src: "./pid-symbols/Screen.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img414",
    group: "P Scheme Green Boxes",
    category: "Sludge Tank 72m3",
    src: "./pid-symbols/SludgeTank72m3A.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img415",
    group: "P Scheme Green Boxes",
    category: "Sludge Tank 185m3",
    src: "./pid-symbols/SludgeTank185m3B.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img416",
    group: "P Scheme Green Boxes",
    category: "Sludge Tank 350m3",
    src: "./pid-symbols/SludgeTank350m3C.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img417",
    group: "P Scheme Green Boxes",
    category: "Tertiary Package - ATAC",
    src: "./pid-symbols/TertiaryPackageATAC.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img418",
    group: "P Scheme Green Boxes",
    category: "Tertiary Package - FLI",
    src: "./pid-symbols/TertiaryPackageFLI.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img419",
    group: "P Scheme Green Boxes",
    category: "Tertiary Package - HYROK",
    src: "./pid-symbols/TertiaryPackageHYROK.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img420",
    group: "P Scheme Green Boxes",
    category: "Tertiary PS Gorman-Rupp T3 2 Pumps",
    src: "./pid-symbols/TertiaryPSGormanRuppT32Pumps.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img421",
    group: "P Scheme Green Boxes",
    category: "Tertiary PS Gorman-Rupp T3 3 Pumps",
    src: "./pid-symbols/TertiaryPSGormanRuppT33Pumps.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img422",
    group: "P Scheme Green Boxes",
    category: "Tertiary PS Gorman-Rupp T4 2 Pumps",
    src: "./pid-symbols/TertiaryPSGormanRuppT42Pumps.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img423",
    group: "P Scheme Green Boxes",
    category: "Tertiary PS Gorman-Rupp T4 3 Pumps",
    src: "./pid-symbols/TertiaryPSGormanRuppT43Pumps.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img424",
    group: "P Scheme Green Boxes",
    category: "Tertiary PS MONO B 2 Pumps",
    src: "./pid-symbols/TertiaryPSMONOB2Pumps.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img425",
    group: "P Scheme Green Boxes",
    category: "Tertiary PS MONO B 3 Pumps",
    src: "./pid-symbols/TertiaryPSMONOB3Pumps.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img426",
    group: "P Scheme Green Boxes",
    category: "Tertiary PS MONO C 2 Pumps",
    src: "./pid-symbols/TertiaryPSMONOC2Pumps.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img427",
    group: "P Scheme Green Boxes",
    category: "Tertiary PS MONO C 3 Pumps",
    src: "./pid-symbols/TertiaryPSMONOC3Pumps.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },{
    id: "img428",
    group: "WNI Assemblies",
    category: "Aeration Tower",
    src: "./pid-symbols/Aeration_Tower.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img429",
    group: "WNI Assemblies",
    category: "Aluminium - Combined Drains",
    src: "./pid-symbols/Aluminium_-_Combined_Drains.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img430",
    group: "WNI Assemblies",
    category: "Aluminium - Seperate Drains",
    src: "./pid-symbols/Aluminium_-_Seperate_Drains.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img431",
    group: "WNI Assemblies",
    category: "Blower Arrangment",
    src: "./pid-symbols/Blower_Arrangment.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img432",
    group: "WNI Assemblies",
    category: "Chemical Dosing Static Mixer (Single)",
    src: "./pid-symbols/Chemical_Dosing_Static_Mixer_(Single).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img433",
    group: "WNI Assemblies",
    category: "Contact Tank",
    src: "./pid-symbols/Contact_Tank.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img434",
    group: "WNI Assemblies",
    category: "Dissolved Oxygen",
    src: "./pid-symbols/Dissolved_Oxygen.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img435",
    group: "WNI Assemblies",
    category: "Fluoride - Combined Drains",
    src: "./pid-symbols/Fluoride_-_Combined_Drains.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img436",
    group: "WNI Assemblies",
    category: "Fluoride - Seperate Drains",
    src: "./pid-symbols/Fluoride_-_Seperate_Drains.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img437",
    group: "WNI Assemblies",
    category: "Free Chlorine",
    src: "./pid-symbols/Free_Chlorine.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img438",
    group: "WNI Assemblies",
    category: "Gac Sample Waste Dechlorination",
    src: "./pid-symbols/Gac_Sample_Waste_Dechlorination.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img439",
    group: "WNI Assemblies",
    category: "Iron - Combined Drains",
    src: "./pid-symbols/Iron_-_Combined_Drains.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img440",
    group: "WNI Assemblies",
    category: "Iron - Seperate Drains",
    src: "./pid-symbols/Iron_-_Seperate_Drains.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },

  {
    id: "img441",
    group: "WNI Assemblies",
    category: "Nitrate",
    src: "./pid-symbols/Nitrate.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img442",
    group: "WNI Assemblies",
    category: "pH Monitor (Acidity)",
    src: "./pid-symbols/pH_Monitor_(Acidity).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img443",
    group: "WNI Assemblies",
    category: "Phosphate - Combined Drains",
    src: "./pid-symbols/Phosphate_-_Combined_Drains.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img444",
    group: "WNI Assemblies",
    category: "Phosphate - Seperate Drains",
    src: "./pid-symbols/Phosphate_-_Seperate_Drains.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img445",
    group: "WNI Assemblies",
    category: "PRV On Bypass",
    src: "./pid-symbols/PRV_On_Bypass.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img446",
    group: "WNI Assemblies",
    category: "Sample Pump Arrangement",
    src: "./pid-symbols/Sample_Pump_Arrangement.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img447",
    group: "WNI Assemblies",
    category: "Sampling Kiosk [Product Ref. No. 216]",
    src: "./pid-symbols/Sampling_Kiosk_[Product_Ref._No._216].png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img448",
    group: "WNI Assemblies",
    category: "Standard Pressure Tapping With Two Monoblock Valves",
    src: "./pid-symbols/Standard_Pressure_Tapping_With_Two_Monoblock_Valves.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img449",
    group: "WNI Assemblies",
    category: "Standard Pressure Tapping With Two Valves",
    src: "./pid-symbols/Standard_Pressure_Tapping_With_Two_Valves.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img450",
    group: "WNI Assemblies",
    category: "Standard Pump Arrangment",
    src: "./pid-symbols/Standard_Pump_Arrangment.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img451",
    group: "WNI Assemblies",
    category: "Total Chlorine - Control Only",
    src: "./pid-symbols/Total_Chlorine_-_Control_Only.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img452",
    group: "WNI Assemblies",
    category: "Total Chlorine - Measurement Only",
    src: "./pid-symbols/Total_Chlorine_-_Measurement_Only.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img453",
    group: "WNI Assemblies",
    category: "Turbidity (With Bubble Trap)",
    src: "./pid-symbols/Turbidity_(With_Bubble_Trap).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img454",
    group: "WNI Assemblies",
    category: "Turbidity Default Choice",
    src: "./pid-symbols/Turbidity_Default_Choice.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img455",
    group: "WNI Assemblies",
    category: "Turbidity With Bubble Trap And Self Cleaning Unit For Raw Water & Waste Streams",
    src: "./pid-symbols/Turbidity_With_Bubble_Trap_And_Self_Cleaning_Unit_For_Raw_Water_&_Waste_Streams.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img456",
    group: "WNI Assemblies",
    category: "Turbidity With Self Cleaning Unit For Raw Water & Waste Streams",
    src: "./pid-symbols/Turbidity_With_Self_Cleaning_Unit_For_Raw_Water_&_Waste_Streams.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img457",
    group: "WNI Assemblies",
    category: "UV Reactor [Product Ref. No 65A]",
    src: "./pid-symbols/UV_Reactor_[Product_Ref_No_65A].png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img458",
    group: "WNI Assemblies",
    category: "UV Transmissivity (Treatment)",
    src: "./pid-symbols/UV_Transmissivity_(Treatment).png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img459",
    group: "WNI Assemblies",
    category: "Venturi Aeration",
    src: "./pid-symbols/Venturi_Aeration.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img460",
    group: "WNI Assemblies",
    category: "Vertical Pressure Filter",
    src: "./pid-symbols/Vertical_Pressure_Filter.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
  {
    id: "img461",
    group: "WNI Assemblies",
    category: "Washwater Settlement Tank",
    src: "./pid-symbols/Washwater_Settlement_Tank.png",
    StaticProps1: "",
    StaticProps2: "",
    StaticProps3: "",
    StaticProps4: "",
    StaticProps5: "",
    StaticProps6: "",
    StaticProps7: "",
  },
];
